import eyeIcon from './../Assets/icons/eye 1.svg'
import editIcon from './../Assets/icons/Un-Checkbox.svg'

export const TABLE_HEADERS = [
    // "Sr No.",
    "Warranty",
    "Warranty Name",
"Warranty Type",
// "Warranty Category",
"Warranty Replacement Period",
// "Warranty Description",
    "Status",
    "Action"
  ];
  
  export const TABLE_DATA = [
    { id: 1, days: "One Month", description:"lorem ipsum",status: "Active", actions: "Edit/Delete" },
    { id: 2, days: "Two Month", description:"lorem ipsum",  status: "Inactive", actions: "Edit/Delete" },
    { id: 3, days: "Three Month", description:"lorem ipsum",  status: "Active", actions: "Edit/Delete" },
  ];
  
  export const keyMapping = {
    // "Sr No.": "Sr No.",
    "Warranty": "warranty",
    "Warranty Name":"warranty_name",
    // "Warranty Category":"warranty_category_name",
    "Warranty Replacement Period":"warranty_replace_value",
    "Warranty Type":"warranty_type_desc",  
    // "Warranty Description":"warranty_type_desc",  
    "Status": "status", 
    "Action": [
        { type: "edit", icon: editIcon, label: "Edit" },
        
      ]
  };